import { render, staticRenderFns } from "./ColorPickerColorToChange.vue?vue&type=template&id=2234f49b&scoped=true&"
import script from "./ColorPickerColorToChange.vue?vue&type=script&lang=js&"
export * from "./ColorPickerColorToChange.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerColorToChange.vue?vue&type=style&index=0&id=2234f49b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2234f49b",
  null
  
)

export default component.exports